import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle.
 * Keeps the existing `.cec-input` styles intact.
 */
export default function PasswordInput({
  value,
  onChange,
  testId,
  autoComplete = "current-password",
  required = true,
  minLength,
  autoFocus = false,
  placeholder,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="cec-input pr-12"
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-bone-muted hover:text-blood transition-colors focus:outline-none focus:text-blood"
        tabIndex={-1}
        aria-label={visible ? "Esconder password" : "Mostrar password"}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
